import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const types = {
	TOKEN: 'TOKEN',
	MEMBER_INFO: 'MEMBER_INFO',
	SET_LOL_TOP: 'SET_LOL_TOP',
	SET_DOTA_TOP: 'SET_DOTA_TOP',
	SET_CSGO_TOP: 'SET_CSGO_TOP',
	SET_KOG_TOP: 'SET_KOG_TOP',
	SET_LOL_COLLECT: 'SET_LOL_COLLECT',
	SET_DOTA_COLLECT: 'SET_DOTA_COLLECT',
	SET_CSGO_COLLECT: 'SET_CSGO_COLLECT',
	SET_KOG_COLLECT: 'SET_KOG_COLLECT'
}

export default new Vuex.Store({
	state: {
		token: '',
		minfo: {},
		lolTopIds: localStorage.getItem('gaming_lol_top_ids') ? JSON.parse(localStorage.getItem('gaming_lol_top_ids')) : [],
		dotaTopIds: localStorage.getItem('gaming_dota_top_ids') ? JSON.parse(localStorage.getItem('gaming_dota_top_ids')) : [],
		csgoTopIds: localStorage.getItem('gaming_csgo_top_ids') ? JSON.parse(localStorage.getItem('gaming_csgo_top_ids')) : [],
		kogTopIds: localStorage.getItem('gaming_kog_top_ids') ? JSON.parse(localStorage.getItem('gaming_kog_top_ids')) : [],
		lolCollectIds: localStorage.getItem('gaming_lol_collect_ids') ? JSON.parse(localStorage.getItem('gaming_lol_collect_ids')) : [],
		dotaCollectIds: localStorage.getItem('gaming_dota_collect_ids') ? JSON.parse(localStorage.getItem('gaming_dota_collect_ids')) : [],
		csgoCollectIds: localStorage.getItem('gaming_csgo_collect_ids') ? JSON.parse(localStorage.getItem('gaming_csgo_collect_ids')) : [],
		kogCollectIds: localStorage.getItem('gaming_kog_collect_ids') ? JSON.parse(localStorage.getItem('gaming_kog_collect_ids')) : [],
		ballType:[],
	},
	mutations: {
		SET_TYPES(state, payload) {
			state.ballType = payload; 
		},
		[types.TOKEN](state, payload) {
			state.token = payload
		},
		[types.MEMBER_INFO](state, minfo) {
			state.minfo = minfo
		},
		// 置顶
		[types.SET_LOL_TOP](state, id) {
			if (state.lolTopIds.includes(id)) {
				state.lolTopIds.splice(state.lolTopIds.indexOf(id), 1)
			} else {
				state.lolTopIds.push(id)
			}
			localStorage.setItem('gaming_lol_top_ids', JSON.stringify(state.lolTopIds)	)
		},
		[types.SET_DOTA_TOP](state, id) {
			if (state.dotaTopIds.includes(id)) {
				state.dotaTopIds.splice(state.dotaTopIds.indexOf(id), 1)
			} else {
				state.dotaTopIds.push(id)
			}
			localStorage.setItem('gaming_dota_top_ids', JSON.stringify(state.dotaTopIds)	)
		},
		[types.SET_CSGO_TOP](state, id) {
			if (state.csgoTopIds.includes(id)) {
				state.csgoTopIds.splice(state.csgoTopIds.indexOf(id), 1)
			} else {
				state.csgoTopIds.push(id)
			}
			localStorage.setItem('gaming_csgo_top_ids', JSON.stringify(state.csgoTopIds)	)
		},
		[types.SET_KOG_TOP](state, id) {
			if (state.kogTopIds.includes(id)) {
				state.kogTopIds.splice(state.kogTopIds.indexOf(id), 1)
			} else {
				state.kogTopIds.push(id)
			}
			localStorage.setItem('gaming_kog_top_ids', JSON.stringify(state.kogTopIds)	)
		},
		// 收藏
		[types.SET_LOL_COLLECT](state, id) {
			if (state.lolCollectIds.includes(id)) {
				state.lolCollectIds.splice(state.lolCollectIds.indexOf(id), 1)
			} else {
				state.lolCollectIds.push(id)
			}
			localStorage.setItem('gaming_lol_collect_ids', JSON.stringify(state.lolCollectIds)	)
		},
		[types.SET_DOTA_COLLECT](state, id) {
			if (state.dotaCollectIds.includes(id)) {
				state.dotaCollectIds.splice(state.dotaCollectIds.indexOf(id), 1)
			} else {
				state.dotaCollectIds.push(id)
			}
			localStorage.setItem('gaming_dota_collect_ids', JSON.stringify(state.dotaCollectIds)	)
		},
		[types.SET_CSGO_COLLECT](state, id) {
			if (state.csgoCollectIds.includes(id)) {
				state.csgoCollectIds.splice(state.csgoCollectIds.indexOf(id), 1)
			} else {
				state.csgoCollectIds.push(id)
			}
			localStorage.setItem('gaming_csgo_collect_ids', JSON.stringify(state.csgoCollectIds)	)
		},
		[types.SET_KOG_COLLECT](state, id) {
			if (state.kogCollectIds.includes(id)) {
				state.kogCollectIds.splice(state.kogCollectIds.indexOf(id), 1)
			} else {
				state.kogCollectIds.push(id)
			}
			localStorage.setItem('gaming_kog_collect_ids', JSON.stringify(state.kogCollectIds)	)
		}
	},
	actions: {
		setToken({ commit }, token = false) {
			commit(types.TOKEN, token)
		},
		setMemberInfo({ commit }, minfo) {
			commit(types.MEMBER_INFO, minfo)
		},
		setLolTop({ commit }, id) {
			commit(types.SET_LOL_TOP, id)
		},
		setDotaTop({ commit }, id) {
			commit(types.SET_DOTA_TOP, id)
		},
		setCsgoTop({ commit }, id) {
			commit(types.SET_CSGO_TOP, id)
		},
		setKogTop({ commit }, id) {
			commit(types.SET_KOG_TOP, id)
		},
		setLolCollect({ commit }, id) {
			commit(types.SET_LOL_COLLECT, id)
		},
		setDotaCollect({ commit }, id) {
			commit(types.SET_DOTA_COLLECT, id)
		},
		setCsgoCollect({ commit }, id) {
			commit(types.SET_CSGO_COLLECT, id)
		},
		setKogCollect({ commit }, id) {
			commit(types.SET_KOG_COLLECT, id)
		}
	}
})
